import Home from './views/Home.vue'
import Login from './views/Login.vue'

const markets = {Base: -1, FX: 1, IR: 2, AG: 3, Metal: 4, Energy: 5, Other: 6}

const sitemap = [
  {
    path: '/',
    name: 'home',
    component: Home,
    meta: {
      text: 'Home',
      requiresAuth: true,
    },
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: {
      text: 'Login',
    },
  },
  //###############################################################
  //####################### LIST ##################################
  {
    path: '/list/otc-trade',
    name: 'list-otc-trade',
    meta: {
      text: 'OTC Trade',
      icon: 'attach_money',
      module: 'Base',
      markets,
      requiresAuth: true,
      readOnlyRoles: ['Guest'],
    },
    component: () => import(/* webpackChunkName: "list" */ './views/List/Deal/Index.vue'),
  },
  {
    path: '/list/otc-histo',
    name: 'list-otc-histo',
    meta: {
      text: 'OTC Histo',
      icon: 'attach_money',
      module: 'Base',
      markets,
      requiresAuth: true,
      readOnlyRoles: ['Guest'],
    },
    component: () =>
      import(/* webpackChunkName: "sitemap" */ './views/Clients/Heroux/List/HerouxTrade.vue'),
  },
  {
    path: '/list/order',
    name: 'list-order',
    meta: {
      text: 'Order',
      icon: 'attach_money',
      requiresAuth: true,
      module: 'Base',
      markets,
      requiresRole: ['Admin', 'SuperAdmin', 'SuperUser', 'Guest', 'Standard'],
      readOnlyRoles: ['Guest'],
    },
    component: () => import(/* webpackChunkName: "list" */ './views/List/Order/Index.vue'),
  },
  {
    path: '/list/Rates',
    name: 'list-Rates',
    meta: {
      text: 'Rates',
      icon: 'show_chart',
      module: 'Base',
      markets,
      requiresAuth: true,
      readOnlyRoles: ['Guest'],
    },
    component: () => import(/* webpackChunkName: "sitemap" */ './views/List/FxRates.vue'),
  },
  {
    path: '/list/cashflow',
    name: 'list-cashflow',
    meta: {
      text: 'CashFlow',
      icon: 'autorenew',
      module: 'Base',
      markets,
      requiresAuth: true,
      readOnlyRoles: ['Guest'],
    },
    component: () => import(/* webpackChunkName: "sitemap" */ './views/List/DivisionForecast.vue'),
  },
  {
    path: '/list/future',
    name: 'list-future',
    meta: {
      text: 'Future',
      icon: 'blur_linear',
      module: 'Base',
      markets,
      requiresAuth: true,
      requiresRole: ['Admin', 'SuperAdmin', 'SuperUser', 'Guest', 'Standard'],
      readOnlyRoles: ['Guest', 'Standard'],
    },
    component: () => import(/* webpackChunkName: "sitemap" */ './views/List/Future/Index.vue'),
  },
  {
    path: '/list/fx-volatility',
    name: 'list-fx-volatility',
    meta: {
      text: 'FX Volatility',
      icon: 'priority_high',
      module: 'Base',
      markets: {FX: 1},
      requiresAuth: true,
      requiresRole: ['Admin', 'SuperAdmin', 'SuperUser', 'Guest', 'Standard'],
      readOnlyRoles: ['Guest', 'Standard'],
    },
    component: () => import(/* webpackChunkName: "sitemap" */ './views/List/FxVolatility.vue'),
  },
  //###############################################################
  //####################### Report ################################
  {
    path: '/report/exposure',
    name: 'exposure-report',
    meta: {
      text: 'Exposure',
      icon: 'fas fa-chart-line',
      module: 'Base',
      markets,
      requiresAuth: true,
      readOnlyRoles: ['Guest', 'Standard'],
    },
    component: () => import(/* webpackChunkName: "reports" */ './views/Report/ExposureReport.vue'),
  },
  {
    path: '/report/exposure-v4',
    name: 'exposure-report-v4',
    meta: {
      text: 'Exposure V4.0',
      icon: 'fas fa-chart-line',
      module: 'Base',
      markets,
      requiresAuth: true,
      readOnlyRoles: ['Guest', 'Standard'],
    },
    component: () => import(/* webpackChunkName: "reports" */ './views/Report/ExposureV4.vue'),
  },
  {
    path: '/report/expiry-option',
    name: 'expiry-option-report',
    meta: {
      text: 'Expiry Option',
      icon: 'fa fa-backspace',
      module: 'Base',
      markets: {FX: 1},
      requiresAuth: true,
      readOnlyRoles: ['Guest', 'Standard'],
    },
    component: () => import(/* webpackChunkName: "reports" */ './views/Report/ExpiryOption.vue'),
  },
  {
    path: '/report/last-next-orders',
    name: 'report-last-next-orders',
    meta: {
      text: 'Last / Next Orders',
      icon: 'fas fa-step-forward',
      module: 'Base',
      markets,
      requiresAuth: true,
      readOnlyRoles: ['Guest', 'Standard'],
    },
    component: () =>
      import(/* webpackChunkName: "reports" */ './views/Report/OrderLastNextTransactions.vue'),
  },
  {
    path: '/report/last-next-transactions',
    name: 'report-last-next-transactions',
    meta: {
      text: 'Last / Next Transactions',
      icon: 'fas fa-fast-forward',
      module: 'Base',
      markets,
      requiresAuth: true,
      readOnlyRoles: ['Guest', 'Standard'],
    },
    component: () =>
      import(/* webpackChunkName: "reports" */ './views/Report/LastNextTransactions.vue'),
  },
  {
    path: '/report/future-past-distributed-hedge',
    name: 'future-past-distributed-hedge',
    meta: {
      text: 'Future/Past Distributed Hedge',
      icon: 'compare_arrows',
      module: 'Base',
      markets,
      requiresAuth: true,
      readOnlyRoles: ['Guest', 'Standard'],
    },
    component: () =>
      import(/* webpackChunkName: "reports" */ './views/Report/FuturePastDistributedHedge.vue'),
  },
  {
    path: '/report/base-marketdata',
    name: 'report-base-marketData',
    meta: {
      text: 'Market Data',
      icon: 'timeline',
      module: 'Base',
      markets: {Base: -1},
      requiresAuth: true,
      readOnlyRoles: ['Guest', 'Standard'],
    },
    component: () => import(/* webpackChunkName: "sitemap" */ './views/Report/MarketData.vue'),
  },
  {
    path: '/report/dashboards',
    name: 'report-dashboards',
    meta: {
      text: 'Dashboards',
      icon: 'art_track',
      module: 'Base',
      markets: {Base: -1},
      requiresAuth: true,
      readOnlyRoles: ['Guest', 'Standard'],
    },
    component: () => import(/* webpackChunkName: "sitemap" */ './views/Report/DashboardTabs.vue'),
  },
  {
    path: '/report/base-dashboard',
    name: 'report-base-dashboard',
    meta: {
      text: 'Dashboard',
      icon: 'art_track',
      module: 'Base',
      markets: {Base: -1},
      requiresAuth: true,
      readOnlyRoles: ['Guest', 'Standard'],
    },
    component: () => import(/* webpackChunkName: "sitemap" */ './views/Report/DashboardPage.vue'),
  },
  {
    path: '/report/dashboard-files',
    name: 'report-dashboard-files',
    meta: {
      text: 'Dashboard Files',
      icon: 'art_track',
      module: 'Base',
      markets: {Base: -1},
      requiresAuth: true,
      readOnlyRoles: ['Guest', 'Standard'],
    },
    component: () => import(/* webpackChunkName: "sitemap" */ './views/Report/DashboardFiles.vue'),
  },
  {
    path: '/report/fx-bid-rate',
    name: 'report-fx-bid-rate',
    meta: {
      text: 'FX Bid Rate',
      icon: 'trending_up',
      module: 'FX',
      markets: {FX: 1},
      requiresAuth: true,
      readOnlyRoles: ['Guest', 'Standard'],
    },
    component: () => import(/* webpackChunkName: "sitemap" */ './views/Report/FxBidRatePricer.vue'),
  },
  {
    path: '/report/master-exposure',
    name: 'report-master-exposure',
    meta: {
      text: 'Master Exposure',
      icon: 'vertical_split',
      module: 'Base',
      markets: {Base: -1},
      requiresAuth: true,
      readOnlyRoles: ['Guest', 'Standard'],
    },
    component: () => import(/* webpackChunkName: "sitemap" */ './views/Report/MasterExposure.vue'),
  },

  //###############################################################
  //####################### month end #########################
  {
    path: '/month end/bon-coup',
    name: 'month-end-bon-coup',
    meta: {
      text: 'Bon Coup',
      icon: 'thumb_up',
      module: 'Base',
      markets: {Base: -1},
      requiresAuth: true,
      readOnlyRoles: ['Guest', 'Standard'],
    },
    component: () => import(/* webpackChunkName: "sitemap" */ './views/Report/DashboardTabs.vue'),
  },
  {
    path: '/month end/undelivered-balance',
    name: 'month-end-undelivered-balance',
    meta: {
      text: 'Undelivered Balance',
      icon: 'fas fa-bullhorn',
      module: 'Base',
      markets: {FX: 1},
      requiresAuth: true,
      readOnlyRoles: ['Guest', 'Standard'],
    },
    component: () =>
      import(/* webpackChunkName: "reports" */ './views/Report/UndeliveredBalance.vue'),
  },
  {
    path: '/month end/message',
    name: 'month-end-message',
    meta: {
      text: 'Message',
      icon: 'mark_email_read',
      module: 'Base',
      markets: {Base: -1},
      requiresAuth: true,
      readOnlyRoles: ['Guest', 'Standard'],
    },
    component: () => import(/* webpackChunkName: "sitemap" */ './views/Config/SendingMessage.vue'),
  },
  {
    path: '/month end/text',
    name: 'month-end-text',
    meta: {
      text: 'Text',
      icon: 'outgoing_mail',
      module: 'Base',
      markets: {Base: -1},
      requiresAuth: true,
      readOnlyRoles: ['Guest', 'Standard'],
    },
    component: () => import(/* webpackChunkName: "sitemap" */ './views/Config/SendText.vue'),
  },

  //###############################################################
  //####################### Config #########################
  {
    path: '/config/sector',
    name: 'config-sector',
    meta: {
      text: 'Sector',
      icon: 'flip_to_front',
      module: 'Base',
      markets: {Base: -1},
      requiresAuth: true,
      readOnlyRoles: ['Guest', 'Standard'],
    },
    component: () => import(/* webpackChunkName: "sitemap" */ './views/Config/Sector.vue'),
  },
  {
    path: '/config/dashboard-scenario',
    name: 'dashboard-scenario',
    meta: {
      text: 'Dashboard Scenarios',
      icon: 'flip_to_back',
      module: 'Base',
      markets: {Base: -1},
      requiresAuth: true,
      readOnlyRoles: ['Guest', 'Standard'],
    },
    component: () =>
      import(/* webpackChunkName: "sitemap" */ './views/Config/DashboardScenario/Index.vue'),
  },

  {
    path: '/config/division',
    name: 'config-division',
    meta: {
      text: 'Division',
      icon: 'flip_to_back',
      module: 'Base',
      markets: {Base: -1},
      requiresAuth: true,
      readOnlyRoles: ['Guest', 'Standard'],
    },
    component: () => import(/* webpackChunkName: "sitemap" */ './views/Config/Division/Index.vue'),
  },
  {
    path: '/config/productDivision',
    name: 'config-product-division',
    meta: {
      text: 'Product Division',
      icon: 'highlight_alt',
      module: 'Base',
      markets: {Base: -1},
      requiresAuth: true,
      readOnlyRoles: ['Guest', 'Standard'],
    },
    component: () => import(/* webpackChunkName: "sitemap" */ './views/Config/ProductDivision.vue'),
  },
  {
    path: '/config/counterparty',
    name: 'config-counterparty',
    meta: {
      text: 'Counterparty',
      icon: 'account_balance',
      module: 'Base',
      markets: {Base: -1},
      requiresAuth: true,
      readOnlyRoles: ['Guest', 'Standard'],
    },
    component: () => import(/* webpackChunkName: "sitemap" */ './views/Config/Counterparty.vue'),
  },
  {
    path: '/config/period',
    name: 'config-period',
    meta: {
      text: 'Period',
      icon: 'calendar_today',
      module: 'Base',
      markets: {Base: -1},
      requiresAuth: true,
      readOnlyRoles: ['Guest', 'Standard'],
    },
    component: () => import(/* webpackChunkName: "sitemap" */ './views/Config/Period/Index.vue'),
  },
  {
    path: '/config/CommodityCurrency',
    name: 'config-commodity-currency',
    meta: {
      text: 'Commodity Currency',
      icon: 'fas fa-hand-holding-usd',
      module: 'Base',
      markets: {Base: -1},
      requiresAuth: true,
      readOnlyRoles: ['Guest', 'Standard'],
    },
    component: () => import(/* webpackChunkName: "sitemap" */ './views/Config/Currency.vue'),
  },
  {
    path: '/config/CommodityCcyPair',
    name: 'config-commodity-ccy-pair',
    meta: {
      text: 'Commodity Ccy Pair',
      icon: 'fas fa-file-invoice-dollar',
      module: 'Base',
      markets: {Base: -1},
      requiresAuth: true,
      readOnlyRoles: ['Guest', 'Standard'],
    },
    component: () => import(/* webpackChunkName: "sitemap" */ './views/Config/CcyPair.vue'),
  },
  {
    path: '/config/HedgePolicy',
    name: 'config-hedgePolicy',
    meta: {
      text: 'Hedge Policy',
      icon: 'vertical_split',
      module: 'Base',
      markets,
      requiresAuth: true,
      readOnlyRoles: ['Guest', 'Standard'],
    },
    component: () => import(/* webpackChunkName: "sitemap" */ './views/Config/HedgePolicy.vue'),
  },
  {
    path: '/config/flowType',
    name: 'config-base-flowType',
    meta: {
      text: 'Flow Type',
      icon: 'fas fa-th-list',
      module: 'Base',
      markets: {Base: -1},
      requiresAuth: true,
      readOnlyRoles: ['Guest', 'Standard'],
    },
    component: () => import(/* webpackChunkName: "sitemap" */ './views/Config/FlowType/Index.vue'),
  },
  {
    path: '/config/base-HedgeType',
    name: 'config-base-hedgeType',
    meta: {
      text: 'Hedge Type',
      icon: 'library_books',
      module: 'Base',
      markets: {Base: -1},
      requiresAuth: true,
      readOnlyRoles: ['Guest', 'Standard'],
    },
    component: () => import(/* webpackChunkName: "sitemap" */ './views/Config/HedgeType/Index.vue'),
    props: {
      marketId: 1,
    },
  },
  {
    path: '/config/GroupCategory',
    name: 'config-groupCategory',
    meta: {
      text: 'Group Category',
      icon: 'group_work',
      module: 'Base',
      markets: {Base: -1},
      requiresAuth: true,
      readOnlyRoles: ['Guest', 'Standard'],
    },
    component: () => import(/* webpackChunkName: "sitemap" */ './views/Config/GroupCategory.vue'),
  },
  {
    path: '/config/future-contract',
    name: 'config-base-future',
    meta: {
      text: 'Future Contract',
      icon: 'blur_linear',
      module: 'Base',
      markets: {Base: -1},
      requiresAuth: true,
      requiresRole: ['Admin', 'SuperAdmin', 'SuperUser', 'Guest', 'Standard'],
      readOnlyRoles: ['Guest', 'Standard', 'SuperUser'],
    },
    component: () => import(/* webpackChunkName: "sitemap" */ './views/Config/Future/Index.vue'),
  },
  {
    path: '/config/volatilityCurves',
    name: 'config-volatility-curves',
    meta: {
      text: 'FX Volatility Curves',
      icon: 'request_quote',
      module: 'Base',
      markets: {Base: -1},
      requiresAuth: true,
      readOnlyRoles: ['Guest', 'Standard'],
    },
    component: () =>
      import(/* webpackChunkName: "sitemap" */ './views/Config/VolatilityCurves.vue'),
  },
  {
    path: '/config/fxAlert',
    name: 'config-fx-alert',
    meta: {
      text: 'FX Alert',
      icon: 'request_quote',
      module: 'Base',
      markets: {Base: -1},
      requiresAuth: true,
      readOnlyRoles: ['Guest', 'Standard'],
    },
    component: () => import(/* webpackChunkName: "sitemap" */ './views/Config/FxAlert.vue'),
  },
  //###############################################################
  //####################### Process ###############################
  {
    path: '/process/manager',
    name: 'process-manager',
    meta: {
      text: 'Process Manager',
      icon: 'fas fa-cogs',
      module: 'Base',
      markets: {Base: -1},
      requiresAuth: true,
      requiresRole: ['Admin', 'SuperAdmin', 'SuperUser'],
      readOnlyRoles: ['Guest', 'Standard'],
    },
    component: () => import(/* webpackChunkName: "sitemap" */ './views/Process/ProcessManager.vue'),
  },
  //###############################################################
  //####################### Client ################################
  {
    path: '/client/list',
    name: 'client-list',
    meta: {
      text: 'List',
      icon: 'view_list',
      module: 'Base',
      markets: {Base: -1},
      requiresAuth: true,
      requiresRole: ['SuperAdmin'],
      readOnlyRoles: ['Admin', 'Guest', 'Standard'],
    },
    component: () => import(/* webpackChunkName: "config" */ './views/Config/Client/Index.vue'),
  },
  {
    path: '/client/profile',
    name: 'client-profile',
    meta: {
      text: 'Profile',
      icon: 'fa-user-circle',
      module: 'Base',
      markets: {Base: -1},
      requiresAuth: true,
      requiresRole: ['Admin', 'SuperAdmin'],
      readOnlyRoles: ['SuperUser', 'Guest', 'Standard'],
    },
    component: () => import(/* webpackChunkName: "config" */ './views/Config/Client/Profile.vue'),
  },
  {
    path: '/client/features',
    name: 'client-configuration',
    component: () =>
      import(/* webpackChunkName: "sitemap" */ './views/ApplicationConfiguration.vue'),
    meta: {
      text: 'Features',
      icon: 'settings_system_daydream',
      module: 'Base',
      markets: {Base: -1},
      requiresAuth: true,
      requiresRole: ['SuperAdmin', 'Admin'],
      readOnlyRoles: ['Admin', 'SuperUser', 'Guest', 'Standard'],
    },
  },
  {
    path: '/client/users',
    name: 'user-manager',
    component: () => import(/* webpackChunkName: "sitemap" */ './views/UserManager.vue'),
    meta: {
      text: 'Users',
      icon: 'supervisor_account',
      module: 'Base',
      markets: {Base: -1},
      requiresAuth: true,
      requiresRole: ['Admin', 'SuperAdmin'],
      readOnlyRoles: ['SuperUser', 'Guest', 'Standard'],
    },
  },
  //###############################################################
  //####################### Security ##############################
  {
    path: '/security/auditLog',
    name: 'security-audit-log',
    meta: {
      text: 'Audit',
      icon: 'line_weight',
      module: 'Base',
      markets: {Base: -1},
      requiresAuth: true,
      requiresRole: ['Admin', 'SuperAdmin'],
    },
    component: () => import(/* webpackChunkName: "sitemap" */ './views/AuditLog.vue'),
  },
  //###############################################################
  //####################### Heroux Client #########################
  {
    path: '/list/fx-designation',
    name: 'list-fx-designation',
    meta: {
      text: 'Fx Designation',
      icon: 'attach_money',
      module: 'FX',
      markets: {FX: 1},
      requiresAuth: true,
      readOnlyRoles: ['Guest'],
    },
    component: () =>
      import(/* webpackChunkName: "sitemap" */ './views/Clients/Heroux/List/FxDesignation.vue'),
  },
  {
    path: '/list/tradeEvaluation',
    name: 'list-trade-evaluation',
    meta: {
      text: 'Trade Evaluation',
      icon: 'attach_money',
      module: 'FX',
      markets: {FX: 1},
      requiresAuth: true,
      readOnlyRoles: ['Guest'],
    },
    component: () =>
      import(/* webpackChunkName: "sitemap" */ './views/Clients/Heroux/List/TradeEvaluation.vue'),
  },
  {
    path: '/list/instruction',
    name: 'list-instruction',
    meta: {
      text: 'Instruction',
      icon: 'attach_money',
      module: 'FX',
      markets: {FX: 1},
      requiresAuth: true,
      readOnlyRoles: ['Guest'],
    },
    component: () =>
      import(/* webpackChunkName: "sitemap" */ './views/Clients/Heroux/List/Instruction.vue'),
  },
  {
    path: '/report/HerouxExposure',
    name: 'heroux-exposure-report',
    meta: {
      text: 'Heroux FX Exposure',
      icon: 'fas fa-chart-line',
      module: 'FX',
      markets: {FX: 1},
      requiresAuth: true,
      readOnlyRoles: ['Guest', 'Standard'],
    },
    component: () =>
      import(/* webpackChunkName: "reports" */ './views/Clients/Heroux/Report/ExposureReport/Index.vue'),
  },
  {
    path: '/report/FfecReconciliation',
    name: 'heroux-report-ffec-rec',
    meta: {
      text: 'FFEC Reconciliation',
      icon: 'speaker_notes',
      module: 'FX',
      markets: {FX: 1},
      requiresAuth: true,
      readOnlyRoles: ['Guest', 'Standard'],
    },
    component: () =>
      import(/* webpackChunkName: "sitemap" */ './views/Clients/Heroux/Reports/FfecReconciliation.vue'),
  },
  {
    path: '/report/RollSummary',
    name: 'heroux-report-roll-summary',
    meta: {
      text: 'Roll Summary',
      icon: 'rotate_left',
      module: 'FX',
      markets: {FX: 1},
      requiresAuth: true,
      readOnlyRoles: ['Guest', 'Standard'],
    },
    component: () =>
      import(/* webpackChunkName: "sitemap" */ './views/Clients/Heroux/Reports/RollSummary.vue'),
  },
  {
    path: '/report/Summary',
    name: 'heroux-report-summary',
    meta: {
      text: 'Summary',
      icon: 'vertical_split',
      module: 'FX',
      markets: {FX: 1},
      requiresAuth: true,
      readOnlyRoles: ['Guest', 'Standard'],
    },
    component: () =>
      import(/* webpackChunkName: "sitemap" */ './views/Clients/Heroux/Reports/Summary.vue'),
  },
  {
    path: '/config/HerouxPeriod',
    name: 'config-heroux-period',
    meta: {
      text: 'Period',
      icon: 'calendar_today',
      module: 'Base',
      markets: {Base: -1},
      requiresAuth: true,
      readOnlyRoles: ['Guest', 'Standard'],
    },
    component: () =>
      import(/* webpackChunkName: "sitemap" */ './views/Clients/Heroux/Config/Period.vue'),
  },
  {
    path: '/config/signator',
    name: 'config-signator',
    meta: {
      text: 'Signator',
      icon: 'gesture',
      module: 'Base',
      markets: {Base: -1},
      requiresAuth: true,
      readOnlyRoles: ['Guest'],
    },
    component: () =>
      import(/* webpackChunkName: "sitemap" */ './views/Clients/Heroux/List/Signator.vue'),
  },
  {
    path: '/config/sector-account',
    name: 'config-sector-account',
    meta: {
      text: 'Account',
      icon: 'attach_money',
      module: 'Base',
      markets: {Base: -1},
      requiresAuth: true,
      readOnlyRoles: ['Guest'],
    },
    component: () =>
      import(/* webpackChunkName: "sitemap" */ './views/Clients/Heroux/List/SectorAccount.vue'),
  },
  {
    path: '/marketdata/currency',
    name: 'heroux-marketdata-currency-rate',
    meta: {
      text: 'Currency',
      icon: 'show_chart',
      module: 'Base',
      requiresAuth: true,
      requiresRole: ['Admin', 'SuperAdmin', 'SuperUser'],
      readOnlyRoles: ['Guest', 'Standard'],
    },
    component: () =>
      import(/* webpackChunkName: "sitemap" */ './views/Clients/Heroux/MarketData/InterestRate/Index.vue'),
    props: {
      rateType: 4,
    },
  },
  {
    path: '/marketdata/spot-rate',
    name: 'heroux-md-spot-rate',
    meta: {
      text: 'Spot Rate',
      icon: 'fas fa-dot-circle',
      module: 'Base',
      requiresAuth: true,
      requiresRole: ['Admin', 'SuperAdmin', 'SuperUser'],
      readOnlyRoles: ['Guest', 'Standard'],
    },
    component: () =>
      import(/* webpackChunkName: "sitemap" */ './views/Clients/Heroux/MarketData/FxRate/Index.vue'),
  },
  {
    path: '/marketdata/reset-ccy-rate',
    name: 'heroux-md-reset-ccy-rate',
    meta: {
      text: 'Reset Ccy Rate',
      icon: 'fas fa-dot-circle',
      module: 'Base',
      requiresAuth: true,
      requiresRole: ['Admin', 'SuperAdmin', 'SuperUser'],
      readOnlyRoles: ['Guest', 'Standard'],
    },
    component: () =>
      import(/* webpackChunkName: "sitemap" */ './views/Clients/Heroux/MarketData/ResetCcyRate/Index.vue'),
  },
  {
    path: '/marketdata/reset-rate',
    name: 'heroux-md-reset-rate',
    meta: {
      text: 'Reset Rate',
      icon: 'blur_circular',
      module: 'Base',
      requiresAuth: true,
      requiresRole: ['Admin', 'SuperAdmin', 'SuperUser'],
      readOnlyRoles: ['Guest', 'Standard'],
    },
    component: () =>
      import(/* webpackChunkName: "sitemap" */ './views/Clients/Heroux/MarketData/ResetRate/Index.vue'),
  },
  {
    path: '/marketdata/primary-rate',
    name: 'heroux-md-primary-rate',
    meta: {
      text: 'Primary Rate',
      icon: 'blur_circular',
      module: 'Base',
      requiresAuth: true,
      requiresRole: ['Admin', 'SuperAdmin', 'SuperUser'],
      readOnlyRoles: ['Guest', 'Standard'],
    },
    component: () =>
      import(/* webpackChunkName: "sitemap" */ './views/Clients/Heroux/MarketData/PrimaryRate/Index.vue'),
  },
  {
    path: '/marketdata/credit-spread',
    name: 'heroux-md-credit-spread',
    meta: {
      text: 'Credit Spread',
      icon: 'blur_circular',
      module: 'Base',
      requiresAuth: true,
      requiresRole: ['Admin', 'SuperAdmin', 'SuperUser'],
      readOnlyRoles: ['Guest', 'Standard'],
    },
    component: () =>
      import(/* webpackChunkName: "sitemap" */ './views/Clients/Heroux/MarketData/CreditSpread/Index.vue'),
  },
  {
    path: '/marketdata/df-1-months',
    name: 'heroux-md-ir-df-1m',
    meta: {
      text: 'DF 1 Month',
      icon: 'blur_circular',
      module: 'Base',
      requiresAuth: true,
      requiresRole: ['Admin', 'SuperAdmin', 'SuperUser'],
      readOnlyRoles: ['Guest', 'Standard'],
    },
    component: () =>
      import(/* webpackChunkName: "sitemap" */ './views/Clients/Heroux/MarketData/InterestRate/Index.vue'),
    props: {
      rateType: 2,
    },
  },
  {
    path: '/marketdata/zero-rates',
    name: 'heroux-md-zero-rates',
    meta: {
      text: 'Zero Rates',
      icon: 'blur_circular',
      module: 'Base',
      requiresAuth: true,
      requiresRole: ['Admin', 'SuperAdmin', 'SuperUser'],
      readOnlyRoles: ['Guest', 'Standard'],
    },
    component: () =>
      import(/* webpackChunkName: "sitemap" */ './views/Clients/Heroux/MarketData/InterestRate/Index.vue'),
    props: {
      rateType: 1,
    },
  },
  {
    path: '/marketdata/credit-risk',
    name: 'heroux-md-ir-credit-risk',
    meta: {
      text: 'Credit Risk',
      icon: 'blur_circular',
      module: 'Base',
      requiresAuth: true,
      requiresRole: ['Admin', 'SuperAdmin', 'SuperUser'],
      readOnlyRoles: ['Guest', 'Standard'],
    },
    component: () =>
      import(/* webpackChunkName: "sitemap" */ './views/Clients/Heroux/MarketData/InterestRate/Index.vue'),
    props: {
      rateType: 5,
    },
  },
]

export default sitemap
